module.exports = __webpack_public_path__ + "static/media/iprogress_import_template_2022.63576644.xlsx";